/**
 * Register env modules in di
 *
 * TODO(tyler): move remaining modules from src/core/env to here
 * @module
 */
var di = require('core/di');

di.register('env/jquery', require('./jquery'));

